import React, { Component } from "react";
import PropTypes from "prop-types";
import { Popover, PopoverHeader, PopoverBody, Label, Input } from "reactstrap";
import { metadataService } from "../../_services/metadata.service";

export default class SlErrorMessage extends Component {
  render() {
    if (this.props.visible) {
      return (
        <Popover
          placement="top"
          isOpen={this.props.visible}
          target={this.props.target}>
          <PopoverBody>
            {this.props.messageName && metadataService.getMessage(this.props.messageName)}
            {this.props.fieldErrors.map(fieldErr => {
                const fieldName = metadataService.getFieldNameLabel(fieldErr.fieldName);
                const message = metadataService.getMessage(fieldErr.messageName, fieldName);
                return (
                <li><b>{fieldName}</b> : {message}</li>
            )})}
        </PopoverBody>
        </Popover>
      );
    }
    return null;
  }
}

SlErrorMessage.propTypes = {
    visible: PropTypes.bool, //TRUE if this should be visible. 
    messageName: PropTypes.string, //The resource name of the message to display. 
    fieldErrors : PropTypes.array,   //An array of field errors. 
    target: PropTypes.string.isRequired //ID of the target element
};
